export function range(start: number, end: number, step = 1): number[] {
  if (start > end || step < 1) {
    return [];
  }
  return [...Array(end - start + 1).keys()]
    .filter((i) => !(i % step))
    .map((v) => start + v);
}
